<file-manager [initialPath]="initialPath" [featureKey]="'TECH_FILE_MANAGER'"></file-manager>

